// packages/shared/data/verifyPassword.js
import axios from '../config/axios';

export default async function verifyPassword(token, password) {
  const { data } = await axios.post(
    '/password/verify',
    { password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
}
